// extracted by mini-css-extract-plugin
export default {"SkillsContainer":"Skills_SkillsContainer__hD43n","SkillsItemsContainer":"Skills_SkillsItemsContainer__fXWHj","SkillItem":"Skills_SkillItem__l+ghU"};